import styled from 'styled-components';

export default styled.div`
	display: flex;
	align-items: center;
	gap: var(--spacing-x-small);
	min-width: 0;
	flex: 1;

	.motif-dropdown-menu {
		max-width: var(--px-300);
		min-width: unset;
	}
`;
